import { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const formGroupColumnStyleMixin = /*#__PURE__*/css(["", " width:100%;padding:0;font-weight:initial;display:inline-flex;flex-direction:column;flex-wrap:nowrap;justify-content:flex-start;align-content:stretch;align-items:stretch;> *{margin-block-end:", ";:last-child{margin-block-end:0;}}", ""], ({
  fullWidth,
  theme
}) => !fullWidth && `max-width: ${theme.textarea.maxWidth.default};`, ({
  theme
}) => theme.spacing.xxxxsmall.default, isMobile(css(["max-width:", ";> *{margin-block-end:", ";}"], ({
  theme
}) => theme.textarea.maxWidth.mobile, ({
  theme
}) => theme.spacing.xxxsmall.mobile)));

export { formGroupColumnStyleMixin as f };
//# sourceMappingURL=formGroupColumnStyleMixin-BV9VZTKA.js.map
